import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useLocation, useNavigationType } from 'react-router'
import {
  DrawerComponent,
  StickyComponent,
  ToggleComponent,
} from '../../../assets/ts/components'
import { KTIcon } from '../../../helpers'

export function ScrollTop() {
  const location = useLocation()
  const navigationType = useNavigationType()
  const [initialized, setInintialized] = useState(false)
  const restorationTimer = useRef<number | null>(null)
  const previousPathname = useRef(location.pathname)

  useEffect(() => {
    const previous = window.history.scrollRestoration
    window.history.scrollRestoration = 'manual'
    return () => { window.history.scrollRestoration = previous }
  }, [])

  const pluginsReinitialization = () => {
    setTimeout(() => {
      StickyComponent.reInitialization()
      setTimeout(() => {
        ToggleComponent.reinitialization()
        DrawerComponent.reinitialization()
      }, 70)
    }, 140)
  }

  const updateHeaderSticky = () => {
    const stickyHeader = document.body.querySelectorAll(`[data-kt-sticky-name="header"]`)
    if (stickyHeader && stickyHeader.length > 0) {
      const sticky = StickyComponent.getInstance(stickyHeader[0] as HTMLElement)
      if (sticky) {
        sticky.update()
      }
    }
  }

  useEffect(() => {
    if (!initialized) {
      setInintialized(true)
    } else {
      pluginsReinitialization()
    }

    updateHeaderSticky()
  }, [initialized, location.pathname])

  useLayoutEffect(() => {
    const savedPosition = navigationType === 'POP' ? scrollPositions.get(location.key) : undefined
    const isSamePage = previousPathname.current === location.pathname
    const fallbackPosition = isSamePage ? window.scrollY : 0
    let attempts = 0
    previousPathname.current = location.pathname

    const restore = () => {
      const target = savedPosition ?? fallbackPosition
      window.scrollTo({ top: target, behavior: 'auto' })
      attempts += 1

      // Lists can grow after their async data arrives. Retry briefly until the
      // saved position becomes reachable, so back navigation returns to the row.
      if (savedPosition != null && Math.abs(window.scrollY - target) > 2 && attempts < 80) {
        restorationTimer.current = window.setTimeout(restore, 75)
      }
    }

    restorationTimer.current = window.setTimeout(restore, 0)

    return () => {
      if (restorationTimer.current != null) window.clearTimeout(restorationTimer.current)
      scrollPositions.set(location.key, window.scrollY)
      while (scrollPositions.size > MAX_SAVED_POSITIONS) {
        const oldestKey = scrollPositions.keys().next().value as string | undefined
        if (!oldestKey) break
        scrollPositions.delete(oldestKey)
      }
    }
  }, [location.key, location.pathname, navigationType])

  return (
    <div id='kt_scrolltop' className='scrolltop' data-kt-scrolltop='true'>
      <KTIcon iconName='arrow-up' />
    </div>
  )
}

const scrollPositions = new Map<string, number>()
const MAX_SAVED_POSITIONS = 60
